import React from 'react';
import { motion } from 'framer-motion';

const LanguageToggle = ({ lang, setLang }) => {
  return (
    <div className="flex bg-slate-100 p-1 rounded-xl border border-slate-200 shadow-inner">
      <button
        onClick={() => setLang('zh-TW')}
        className={`px-3 py-1 text-xs font-bold rounded-lg transition-all ${
          lang === 'zh-TW' 
          ? 'bg-white text-indigo-600 shadow-sm' 
          : 'text-slate-400 hover:text-slate-600'
        }`}
      >
        中
      </button>
      <button
        onClick={() => setLang('en')}
        className={`px-3 py-1 text-xs font-bold rounded-lg transition-all ${
          lang === 'en' 
          ? 'bg-white text-indigo-600 shadow-sm' 
          : 'text-slate-400 hover:text-slate-600'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;